import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import Link from 'next/link';
import useStyles from './SiteUsp.styles';
import clsx from 'clsx';
import Image from '../Image/Image';
import { SiteContext } from '../../utils/common';
import { useMediaQuery } from '@mui/material';
const SiteUsp = React.memo(function SiteUsp(props) {
    var _a;
    const { title, link, carouselIndex, iconImage, mobileIconSwitch, desktopIconSwitch, iconColor, textColorStyle, backgroundColorStyle, } = props;
    const { isFlyingFlowers } = useContext(SiteContext);
    const { classes } = useStyles({ iconColorStyle: (_a = iconColor === null || iconColor === void 0 ? void 0 : iconColor[0]) === null || _a === void 0 ? void 0 : _a.backgroundColour });
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const showIcon = (isMobile && mobileIconSwitch) || (!isMobile && desktopIconSwitch);
    const hasIcon = !!(iconImage === null || iconImage === void 0 ? void 0 : iconImage.url);
    const textAlignClass = !(hasIcon && showIcon);
    // Common render function for iconImage
    const renderIconImage = (iconImage) => {
        var _a;
        if (iconImage) {
            return (_jsx(Image, { imageUrl: iconImage.url, altText: (_a = iconImage === null || iconImage === void 0 ? void 0 : iconImage.altText) !== null && _a !== void 0 ? _a : '', className: classes.icon, priority: true, height: 18, width: 18 }));
        }
        return null;
    };
    const renderTitleWithLink = (title, linkUrl) => (_jsx(Link, { href: linkUrl, className: clsx(classes.linkWrapper, classes.ukUspHeaderText), style: textColorStyle !== null && textColorStyle !== void 0 ? textColorStyle : undefined, children: _jsx("div", { children: title }) }));
    const renderTitle = (title) => {
        const titleClasses = clsx(classes.ukUspHeaderText, textAlignClass && classes.iconText);
        return (_jsx("div", { className: titleClasses, style: textColorStyle !== null && textColorStyle !== void 0 ? textColorStyle : undefined, children: title }));
    };
    const renderTitleContent = (title, linkUrl) => {
        if (!title)
            return null;
        if (linkUrl) {
            return renderTitleWithLink(title, linkUrl);
        }
        return renderTitle(title);
    };
    const renderUspContainer = (isFF) => {
        const containerClass = classes.ukContainer;
        return (_jsx("div", { className: clsx(classes.uspCommonContainer, containerClass), "data-testid": title, "data-index": carouselIndex, "data-type": "SiteUspGallery", style: backgroundColorStyle !== null && backgroundColorStyle !== void 0 ? backgroundColorStyle : undefined, children: isFF ? (_jsxs(_Fragment, { children: [renderIconImage(iconImage), renderTitleContent(title, link === null || link === void 0 ? void 0 : link.url)] })) : (_jsxs(_Fragment, { children: [showIcon ? renderIconImage(iconImage) : null, renderTitleContent(title, link === null || link === void 0 ? void 0 : link.url)] })) }));
    };
    return renderUspContainer(isFlyingFlowers);
});
export default SiteUsp;
